import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
    transform(text: string, search: string): string {
        if (!text) {
            return '';
        }
        let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        pattern = pattern.split(' ').filter((t) => {
            return t.length > 0;
        }).join('|');
        const regex = new RegExp(pattern, 'gi');

        return search ? text.replace(regex, (match) => `<span class="highlight">${match}</span>`) : text;
    }
}



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/turnos/shared/pipes/highlight.pipe.ts